import React from "react";
import PropTypes from "prop-types";
import distanceInWordsToNow from "date-fns/distance_in_words_to_now";
import differenceInMinutes from "date-fns/difference_in_minutes";
//Material imports
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";
//Limitless imports
import { locale } from "@limitless/common/utils";
import { findInboxExpiryTime } from "@limitless/expert/utils/InboxExpiryHelper";
import { TimeLeftCell } from "@limitless/portal";

const useStyles = makeStyles(theme => ({
    contentHeader: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        marginTop: "6px",
        width: "100%",
        height: "20px"
    },
    header: {
        minWidth: "49%"
    },
    textWrapping: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
    },
    timeContainer: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        maxWidth: "49%"
    },
    newTaskDot: {
        width: "12px",
        height: "12px",
        backgroundColor: theme.palette.secondary.main,
        borderRadius: "50%",
        marginLeft: "6px"
    }
}));

const TaskListItemHeader = ({ t, message }) => {
    const classes = useStyles();

    const expiryTime = findInboxExpiryTime(message);

    const diff = differenceInMinutes(new Date(expiryTime), new Date());

    const translate = React.useMemo(() => locale(t, true), []);

    return (
        <div className={classes.contentHeader}>
            <div className={classes.header}>
                <Typography className={classes.textWrapping} color="primary" variant="subtitle2">
                    {message.displayName ? message.displayName : message.groupName}
                </Typography>
            </div>
            <div className={classes.timeContainer}>
                <Typography className={classes.textWrapping} variant="body1" color="textSecondary" component="div">
                    {diff < 5 || Number.isNaN(diff) ? (
                        <TimeLeftCell value={expiryTime || 0} localiseDate={translate.distanceInWords.localize} />
                    ) : (
                        distanceInWordsToNow(new Date(expiryTime), {
                            includeSeconds: true,
                            addSuffix: true,
                            locale: locale(t, true)
                        })
                    )}
                </Typography>
                {message.new && <span id="newMsgIndicator" className={classes.newTaskDot} />}
            </div>
        </div>
    );
};

export default TaskListItemHeader;

TaskListItemHeader.propTypes = {
    t: PropTypes.func.isRequired,
    message: PropTypes.object.isRequired
};
